export const INSIGHT_SORT_OPTIONS = [
  { label: "Expected effort - high to low", value: "effort", order: "desc" },
  { label: "Expected effort - low to high", value: "effort", order: "asc" },
  { label: "Expected savings - high to low", value: "cost_savings_max", order: "desc" },
  { label: "Expected savings - low to high", value: "cost_savings_max", order: "asc" },
];

export enum InsightStatus {
  ACTIVE = "active",
  IMPLEMENTED = "implemented",
  DISMISSED = "dismissed",
}

type ExplanationContext = { opportunity: { opportunity_id: string }; query_id?: string };

export const isExplanationContext = (value: unknown): value is ExplanationContext =>
  value !== null &&
  typeof value === "object" &&
  "opportunity" in value &&
  typeof (value as Record<string, unknown>).opportunity === "object";
